import React from "react";
import PropTypes from "prop-types";
import { getDefaultName } from "../../pages/alertevent/AlertEvent";
import map from "lodash";
import { AlertEvent as AlertEventType } from "@/components/proptypes";
import FavoritesControl from "@/components/favorites-control/FavoritesControl";
import { AlertEventTagsControl } from "@/components/tags-control/TagsControl";
import getTags from "@/services/getTags";
import { useTheme } from "@/components/ThemeProvider";

import "./Title.less";

function getAlertEventTags() {
  return getTags("api/alert_events/tags").then(tags => map(tags, t => t.name)) || [];
}

export default function Title({ 
  alertEvent, 
  name, 
  children, 
  tagsExtra,
  onChange,  
  canEdit,
  setAlertEventTags,
}) {
  const defaultName = getDefaultName(alertEvent);
  const { isDarkMode } = useTheme();

  return (
    <div className={`alert-event-header ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className={`title-with-tags ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className={`page-title ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className="d-flex align-items-center">
            {alertEvent.id && <FavoritesControl item={alertEvent} />}
            <h3>
              {name || defaultName}
            </h3>
          </div>
        </div>
        <div className={`alert-event-tags ${isDarkMode ? 'dark-mode' : ''}`}>
          <AlertEventTagsControl
            tags={alertEvent.tags}
            isArchived={alertEvent.is_archived}
            canEdit={canEdit}
            getAvailableTags={getAlertEventTags}
            onEdit={setAlertEventTags}
            tagsExtra={tagsExtra}
          />
        </div>
      </div>
      <div className={`header-actions ${isDarkMode ? 'dark-mode' : ''}`}>
        {children}
      </div>
    </div>
  );
}

Title.propTypes = {
  alertEvent: AlertEventType.isRequired,
  name: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  editMode: PropTypes.bool,
  tagsExtra: PropTypes.node,
};

Title.defaultProps = {
  name: null,
  children: null,
  editMode: false,
  tagsExtra: null,
  onChange: () => {},
};
